import {ArrowUpRightIcon} from '@primer/octicons-react'
import {useScrollToComments} from '../../../../comments/use-scroll-to-comments'
import {useAllThreads} from '../../../../../stores/layout-selectors'
import {MiniMergeStatusItem} from './MiniMergeStatusItem'
import {MiniMergeStatusBoundary} from './MiniMergeStatusBoundary'

export function CommentsMiniStatus() {
  const scrollToComments = useScrollToComments()
  const threads = useAllThreads()
  const totalThreads = threads.length
  const resolvedThreads = threads.filter(thread => thread.isResolved).length
  const isUnavailable = totalThreads === 0
  const iconType = totalThreads === 0 ? 'empty' : resolvedThreads === totalThreads ? 'success' : 'warning'
  return (
    <MiniMergeStatusItem
      aria-label={isUnavailable ? 'Resolved comments' : 'View unresolved comments'}
      onClick={isUnavailable ? undefined : scrollToComments}
    >
      <MiniMergeStatusItem.LabelRow icon={isUnavailable ? undefined : ArrowUpRightIcon}>
        <MiniMergeStatusItem.Label
          icon={iconType}
          isUnavailable={isUnavailable}
          successful={resolvedThreads}
          total={totalThreads}
        >
          Resolved comments
        </MiniMergeStatusItem.Label>
      </MiniMergeStatusItem.LabelRow>
      <MiniMergeStatusItem.Progress
        aria-label={`${resolvedThreads} of ${totalThreads} resolved comments`}
        isUnavailable={isUnavailable}
        successful={resolvedThreads}
        total={totalThreads}
        unavailableLabel="No comments available"
      />
    </MiniMergeStatusItem>
  )
}

export function CommentsMiniStatusBoundary({children}: {children: React.ReactNode}) {
  const scrollToComments = useScrollToComments()

  return (
    <MiniMergeStatusBoundary
      action={scrollToComments}
      actionLabel="View unresolved comments"
      boundaryName="CommentsMiniStatusBoundary"
      text="Resolved comments"
    >
      {children}
    </MiniMergeStatusBoundary>
  )
}
